import React from 'react';
import {Route, Switch} from 'react-router-dom';
import App from "./App";
//container
import ForgotPassword from "./container/account_management/ForgotPassword";
import Login from "./container/account_management/Login";
import Signup from "./container/account_management/Signup";
import VerifyMobileNumber from './container/account_management/VerfiyMobileNumber';
import VerifyOTP from './container/account_management/VerifyOTP';
import Dashboard from "./container/Dashboard";
import NoMatch from "./container/NoMatch";
import BroadcasterRegister from "./container/broadcaster/register";
import PendingVerification from "./container/broadcaster/pending_verification";
import CreateBroadcasterProfile from "./container/broadcaster/create_profile";
import StartBroadcast from "./container/broadcast/start_broadcast";
import AvailabilityBroadcast from "./container/broadcast/availability_broadcast";
import ViewBroadcast from "./container/broadcast/ViewBroadcast";
import Countdown from "./container/broadcast/countdown";
import CreateBroadcaster from "./container/broadcast/create_broadcast";
import CreateBroadcastAvailability from "./container/broadcast/CreateBroadcastAvailability";
import Following from "./container/Following";
import BroadcasterDetail from "./container/BroadcasterDetail";
import BroadcastAvailability from "./container/broadcast/BroadcastAvailability";
import BroadcastAvailabilityRequests
    from './container/broadcast/BroadcastAvailabilityRequests/BroadcastAvailabilityRequests'
import SimilarBroadcasters from "./container/Similar-broadcasters";
import Followers from "./container/broadcaster/Followers";
import Favourites from "./container/broadcaster/Favourites";
import Wallet from "./container/broadcaster/Wallet";
import {MyLibraryHomePage} from "./container/broadcaster/MyLibrary";
import CreateVideoContentPage from "./container/broadcaster/MyLibrary/CreateVideoContentPage";
import PublishVideoContent from "./container/broadcaster/MyLibrary/PublishVideoContent";
import GalleryPage from "./container/broadcaster/MyLibrary/GalleryPage";
import VideoDetails from "./container/broadcaster/MyLibrary/VideoDetails";
import BroadcasterProfile from "./container/user/broadcaster/profile";
import UserProfile from "./components/UserProfile";
import ViewerProfile from "./container/user/profile";
import MessagingHomePage from "./container/broadcaster/messaging/home-page";
import ViewerProfileForOthers from "./container/user/profile/others";

export default () => (
    <App>
        <Switch>
            <Route path="/"
                   exact
                   component={Dashboard}/>

            <Route path="/dashboard"
                   component={Dashboard}/>

            <Route path="/dashboard/video/:id"
                   component={Dashboard}/>

            <Route path="/dashboard/gallery/:id"
                   component={Dashboard}/>

            <Route path="/broadcaster/profile/:id"
                   component={BroadcasterProfile}/>

            {/*** * *  * * *  * * *  * * *  * * * B R O A D C A S T E R P R O F I L E   * * *  * * *  * * *  * * *  **/}
            <Route path="/profile/:id"
                   component={BroadcasterProfile}/>

            <Route path="/profile/video/:id"
                   component={BroadcasterProfile}/>

            <Route path="/profile/gallery/:id"
                   component={BroadcasterProfile}/>
            {/*** * *  * * *  * * *  * * *  * * * B R O A D C A S T E R P R O F I L E   * * *  * * *  * * *  * * *  **/}

            {/*** * *  * * *  * * *  * * *  * * * U S E R P R O F I L E   * * *  * * *  * * *  * * *  **/}
            <Route path="/broadcaster/user/profile/:id"
                   component={ViewerProfileForOthers}/>

            <Route path="/user/profile"
                   component={ViewerProfile}/>

            <Route path="/user/profile/video/:id"
                   component={ViewerProfile}/>

            <Route path="/user/profile/gallery/:id"
                   component={ViewerProfile}/>
            {/*** * *  * * *  * * *  * * *  * * * B R O A D C A S T E R P R O F I L E   * * *  * * *  * * *  * * *  **/}

            <Route path="/login"
                   exact
                   component={Login}/>

            <Route path="/forgot-password"
                   exact
                   component={ForgotPassword}/>
            <Route path="/register"
                   exact
                   component={Signup}/>
            <Route path="/verify-mobile"
                   exact
                   component={VerifyMobileNumber}/>

            <Route path="/verify-otp"
                   exact
                   component={VerifyOTP}/>

            <Route path="/broadcaster/register"
                   exact
                   component={BroadcasterRegister}/>

            <Route path="/register/pending"
                   exact
                   component={PendingVerification}/>

            <Route path="/broadcaster/create/profile"
                   exact
                   component={CreateBroadcasterProfile}/>
            <Route path="/broadcaster/availability"
                   exact
                   component={BroadcastAvailability}/>
            <Route path="/broadcaster/availability/requests"
                   exact
                   component={BroadcastAvailabilityRequests}/>
            <Route path="/broadcaster/create/availability"
                   exact
                   component={CreateBroadcastAvailability}/>
            <Route path="/broadcaster/create/broadcast"
                   exact
                   component={CreateBroadcaster}/>

            <Route path="/following"
                   exact
                   component={Following}/>

            <Route path="/following/:id"
                   exact
                   component={BroadcasterDetail}/>

            <Route path="/broadcast/:id"
                   exact
                   component={BroadcasterDetail}/>

            <Route path="/broadcast/start/countdown"
                   exact
                   component={Countdown}/>
            />
            <Route path="/broadcaster/start/broadcast"
                   exact
                   component={StartBroadcast}/>
            />
            <Route path="/broadcaster/start/availability-broadcast"
                   exact
                   component={AvailabilityBroadcast}/>
            />
            <Route path="/similar-broadcasters"
                   exact
                   component={SimilarBroadcasters}/>
            />
            <Route path="/broadcaster/followers"
                   exact
                   component={Followers}/>
            />

            <Route path="/broadcaster/favourites"
                   exact
                   component={Favourites}/>
            />

            <Route path="/broadcaster/wallet"
                   exact
                   component={Wallet}/>
            />

            <Route path="/broadcaster/my-library"
                   exact
                   component={MyLibraryHomePage}/>
            />

            <Route path="/broadcaster/my-library/create"
                   exact
                   component={CreateVideoContentPage}/>
            />

            <Route path="/broadcaster/my-library/publish"
                   exact
                   component={PublishVideoContent}/>
            />

            <Route path="/broadcaster/my-library/gallery"
                   exact
                   component={GalleryPage}/>
            />

            <Route path="/video/:id"
                   component={VideoDetails}/>

            <Route path="/gallery/:id"
                   component={VideoDetails}/>

            <Route path="/picture/:id"
                   component={VideoDetails}/>


            <Route path="/view/broadcast"
                   exact
                   component={ViewBroadcast}/>
            />

            <Route path="/broadcaster/messaging"
                   exact
                   component={MessagingHomePage}/>
            />

            <Route path="/viewer/messaging"
                   exact
                   component={MessagingHomePage}/>
            />

            <Route status={404} component={NoMatch}/>
        </Switch>
    </App>
);
